/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import jwtDecode from 'jwt-decode';
import { getLocalStorage } from './storageUtil';
import { ADMIN_JWT_TOKEN, CLIENT_JWT_TOKEN, PACESETTER_APPLICATION_TYPES, SYSTEM_JWT_TOKEN } from '../constants/appConfig';
import {
  adminLogoutLocalStorage,
  clientLogoutLocalStorage,
  systemLogoutLocalStorage,
} from './authUtil';

const isTokenExpired = token => {
  try {
    const decoded = jwtDecode(token);
    // Checking if token is expired.
    if (decoded.exp < Date.now() / 1000) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

const getSystemToken = () => {
  return getLocalStorage(SYSTEM_JWT_TOKEN);
};
const getAdminToken = () => {
  return getLocalStorage(ADMIN_JWT_TOKEN);
};
const getClientToken = () => {
  return getLocalStorage(CLIENT_JWT_TOKEN);
};

export let isSystemAuthenticated = () => {
  if (isTokenExpired(getSystemToken())) {
    systemLogoutLocalStorage();
  }
  return !!getSystemToken() && !isTokenExpired(getSystemToken());
};
export let isAdminAuthenticated = () => {
  if (isTokenExpired(getAdminToken())) {
    adminLogoutLocalStorage();
  }
  return !!getAdminToken() && !isTokenExpired(getAdminToken());
};
export let isClientAuthenticated = () => {
  if (isTokenExpired(getClientToken())) {
    clientLogoutLocalStorage();
  }
  return !!getClientToken() && !isTokenExpired(getClientToken());
};

/**
 * It returns the remaining time in seconds for a token to expire
 * @returns The remaining time in seconds before the token expires.
 */
export const getTokenRemainingTimeToExpire = tokenUserType => {
  if (!tokenUserType) return false;
  let decoded = undefined;
  try {
    if (tokenUserType === PACESETTER_APPLICATION_TYPES.ADMIN) {
      decoded = jwtDecode(getAdminToken());
    }
    if (tokenUserType === PACESETTER_APPLICATION_TYPES.CLIENT) {
      decoded = jwtDecode(getClientToken());
    }
    if (tokenUserType === PACESETTER_APPLICATION_TYPES.SYSTEM) {
      decoded = jwtDecode(getSystemToken());
    }
    // Checking if token is expired.
    return decoded.exp - Date.now() / 1000;
  } catch (e) {
    return false;
  }
};